import { getSalonBaseDomain, getSalonSlug } from "./salonHost"

export const FOUNDER_FALLBACK_SLUG = "timeless"

export function buildSalonUrl(slug, path = "/") {
  if (!slug) return path

  if (typeof window === "undefined") {
    return `https://${slug}.${getSalonBaseDomain()}${path}`
  }

  const protocol = window.location.protocol
  const port = window.location.port ? `:${window.location.port}` : ""
  const hostname = window.location.hostname

  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".localhost")
  ) {
    return `${protocol}//${slug}.localhost${port}${path}`
  }

  return `${protocol}//${slug}.${getSalonBaseDomain()}${path}`
}

export function getClientEntryPath() {
  return "/client/login"
}

export function pickFirstActiveCompany(companies) {
  if (!Array.isArray(companies) || !companies.length) return null
  const active = companies.filter((company) => company.active !== false)
  if (!active.length) return null
  return [...active].sort((a, b) => Number(a.id) - Number(b.id))[0]
}

export function buildFirstSalonClientLoginUrl(companies) {
  const first = pickFirstActiveCompany(companies)
  const slug = first?.slug || FOUNDER_FALLBACK_SLUG
  return buildSalonUrl(slug, "/client/login")
}

export function buildFounderSalonClientUrl(path = "/client/login", companies) {
  const first = pickFirstActiveCompany(companies)
  const slug = first?.slug || FOUNDER_FALLBACK_SLUG
  return buildSalonUrl(slug, path)
}
